export const buildNotificationFields = ({
  newNotification = {},
  selectedAssign = null,
  setSelectedAssign,
  handleAssignSearch,
  formatAssignOption,
  formatPriorityOption,
  formReadOnly = false,
  editingId = null,
  onImageClick,
  numberLabel = "Notification Number",
}) => {
  const isAssigned =
    newNotification.notificationStatusId === 2 ||
    newNotification.notificationStatus?.name === "Assigned";

  const base = [
    {
      field: "notificationNumber",
      label: numberLabel,
      type: "text",
      size: 6,
      disabled: "disabled",
      placeholder: "Auto-generated on save",
    },
    {
      field: "extNumber",
      label: "External Notification Number",
      type: "text",
      size: 6,
    },
    {
      field: "notificationTitle",
      label: "Title",
      type: "text",
      size: 12,
      required: true,
    },
    {
      field: "notificationDescription",
      label: "Description",
      type: "textarea",
      size: 12,
    },
    {
      field: "assignable",
      label: "Asset or Location (Area)",
      type: "paginated-select",
      size: 6,
      required: true,
      loadOptions: handleAssignSearch,
      selectedOption: selectedAssign,
      setSelectedOption: setSelectedAssign,
      formatOptionLabel: formatAssignOption,
      disabled: Boolean(editingId),
    },
    {
      field: "priorityId",
      label: "Priority",
      type: "select",
      size: 6,
      api: "priority",
      displayField: "name",
      required: true,
      formatOptionLabel: formatPriorityOption,
    },
    {
      field: "teamsId",
      label: "Assigned Team",
      type: "select",
      size: 6,
      api: "teams",
      displayField: "teamName",
    },
    { field: "requesterName", label: "Requester Name", type: "text", size: 6 },
    {
      field: "requesterEmail",
      label: "Requester Email",
      type: "text",
      size: 6,
    },
    {
      field: "requesterPhone",
      label: "Requester Phone",
      type: "text",
      size: 6,
    },
    {
      field: "notificationImages",
      label: "Images",
      type: "images",
      size: 12,
      directory: "workorderimages",
      onImageClick,
      disabled: isAssigned ? "disabled" : undefined,
      maxFiles: 5,
    },
  ];

  if (formReadOnly) {
    return base.map((f) => ({ ...f, disabled: "disabled" }));
  }

  return base;
};
